import React, { useEffect, useRef, useState } from 'react';
import RichText from '../../richtext';
import Styles from './ButtonStyles.module.scss';
import { MyPolicyCallByAction } from '../../../services/LoginServiceV2';
import { Spinner } from 'react-bootstrap';
import { ResetPwdSchema } from '../Login.types';
import mainStyles from '../ReusableLogin.module.scss'

const ResetPwdModal: React.FC<ResetPwdSchema> = ({
  content,
  useCase,
  loginIcons,
  changeCurrentView,
  errorContent
}: any) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [misMatchError, setMisMatchError] = useState<boolean>(false);
  const [matched, setMatched] = useState(false);
  const [error, setError] = useState<boolean>(false);
  const [validationList, setValidationList] = useState<Record<string, any>>([]);
  const [notValidatedCount, setNotValidatedCount] = useState(0);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<Record<string, boolean>>({
    showPswd: false,
    showConfirmPswd: false
  });
  const barWidth = notValidatedCount === 0 ? 0 : (notValidatedCount / validationList?.length) * 100;
  const controllerRef = useRef<AbortController | null>(null);

  const handleTextField = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fieldValue = e?.target?.value ?? '';
    const fieldId = e?.target?.id ?? '';
    if (fieldId === 'password') {
      setPassword(fieldValue);
    }
    if (fieldId === 'confirmPassword') {
      setConfirmPassword(fieldValue);
    }
  };

  const onClickHandler = () => {
    if (showLoader) {
     controllerRef?.current?.abort();
    }
    setShowLoader(true);
    setError(false);
    MyPolicyCallByAction(useCase, password, controllerRef)
      .then((res: any) => {
        if (res?.status) {
          if (res?.status !== 'NOK' && res?.status !== 'ERROR') {
            changeCurrentView('', res);
          } else {
            setError(true);
          }
        } else {
          setError(true);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        setError(true);
        console.log(err);
      });
  };

  const onKeyDown = (e: any) => {
    if (
      e?.key === 'Enter' &&
      !(
        password !== confirmPassword ||
        password === '' ||
        confirmPassword === '' ||
        showLoader ||
        notValidatedCount !== validationList?.length
      )
    ) {
      onClickHandler();
    }
  };

  //checking the entered pswd passes the configured regex's
  useEffect(() => {
    if (content?.pwdReqList?.length > 0) {
      let notValidCount = 0;
      const list = (content?.pwdReqList || [])?.map((val: any) => {
        const result = new RegExp(val?.key)?.test(password);
        if (result) notValidCount += 1;
        return {
          value: val?.value ?? '',
          isValid: result
        };
      });
      setNotValidatedCount(notValidCount);
      setValidationList(list);
    }
  }, [password, content]);

  useEffect(() => {
    if (
      password !== '' &&
      confirmPassword !== '' &&
      password === confirmPassword &&
      barWidth === 100
    ) {
      setMatched(true);
    } else {
      setMatched(false);
    }

    if (confirmPassword !== '' && password !== confirmPassword) {
      setMisMatchError(true);
    } else {
      setMisMatchError(false);
    }
    if (error) setError(false);
  }, [password, confirmPassword]);

  return (
    <div>
      {content && (
        <>
          {content?.title && <h2 className='p-0 my-4 text-center'>{content?.title}</h2>}
          {content?.description && <RichText content={content?.description} />}
          <div className={`form-floating w-100 mt-4`}>
            {/* new password */}
            <input
              type={showPassword?.showPswd ? 'text' : 'password'}
              className={`${matched && mainStyles.inputSuccess} form-control ${
                misMatchError && 'error-border'
              }  pe-5`}
              id='password'
              placeholder={content?.newPwdPlaceholder}
              value={password}
              onChange={handleTextField}
              // disabled={isblocked}
              onKeyDown={onKeyDown}
            />
            <label className={mainStyles.loginmodalLabel}>{content?.newPwdPlaceholder}</label>
            <div className={mainStyles.iconcontainer}>
              <span
                onClick={() =>
                  setShowPassword({ ...showPassword, showPswd: !showPassword?.showPswd })
                }
              >
                {showPassword?.showPswd ? (
                  <img src={loginIcons?.eyeoff?.filename} alt='eyeOff' className={mainStyles.eyeicon} />
                ) : (
                  <img src={loginIcons?.eye?.filename} alt='eye' className={mainStyles.eyeicon} />
                )}
              </span>
            </div>
          </div>

          {/* confirm password */}
          <div className={`form-floating w-100 mt-4 ${misMatchError && 'mb-4'}`}>
            <input
              type={showPassword?.showConfirmPswd ? 'text' : 'password'}
              className={`${matched && mainStyles.inputSuccess} form-control ${
                misMatchError && 'error-border'
              }  pe-5`}
              id='confirmPassword'
              placeholder={content?.cnfrmPwdPlaceholder}
              value={confirmPassword}
              onChange={handleTextField}
              // disabled={isblocked}
              onKeyDown={onKeyDown}
            />
            <label className={mainStyles.loginmodalLabel}>{content?.cnfrmPwdPlaceholder}</label>
            <div className={mainStyles.iconcontainer}>
              <span
                onClick={() =>
                  setShowPassword({
                    ...showPassword,
                    showConfirmPswd: !showPassword?.showConfirmPswd
                  })
                }
              >
                {showPassword?.showConfirmPswd ? (
                  <img src={loginIcons?.eyeoff?.filename} alt='eyeOff' className={mainStyles.eyeicon} />
                ) : (
                  <img src={loginIcons?.eye?.filename} alt='eye' className={mainStyles.eyeicon} />
                )}
              </span>
            </div>

            {misMatchError && errorContent?.resetPwdError && (
              <p className={mainStyles.credentialerror}>
                <img
                  src={loginIcons?.alertTriangle?.filename}
                  alt='alert'
                  className={mainStyles.warningicon}
                />
                {errorContent?.resetPwdError}
              </p>
            )}
            {error && errorContent?.technicalError && (
              <p className={mainStyles.credentialerror}>
                <img
                  src={loginIcons?.alertTriangle?.filename}
                  alt='alert'
                  className={mainStyles.warningicon}
                />
                {errorContent?.technicalError}
              </p>
            )}
          </div>
          <div>
            {content?.pwdStrngthLbl && <div className='mt-4 mb-1'>{content?.pwdStrngthLbl}</div>}
            <div className={Styles.outerBar}>
              <div
                className={`${Styles.innerBar} ${
                  notValidatedCount === validationList?.length ? Styles.great : Styles.good
                }`}
                style={{ width: `${barWidth}%` }}
              ></div>
            </div>
            {validationList?.length > 0 &&
              (validationList || [])?.map((valid: any) => (
                <div className={`${valid?.isValid ? Styles.valid : ''} d-flex align-items-center`}>
                  <img
                    src={
                      valid?.isValid
                        ? loginIcons?.greenTickmark?.filename
                        : loginIcons?.greyTickmark?.filename
                    }
                    alt='tick'
                    width={16}
                    height={16}
                    className='me-1'
                  />
                  {valid?.value}
                </div>
              ))}
          </div>
          {content?.cnfrmBtnLbl && (
            <div className='text-center mt-4'>
              {showLoader && (
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                  className='d-block mx-auto mb-3'
                />
              )}
              <button
                className={Styles.continueButton}
                onClick={onClickHandler}
                disabled={
                  password !== confirmPassword ||
                  password === '' ||
                  confirmPassword === '' ||
                  showLoader ||
                  notValidatedCount !== validationList?.length
                }
              >
                {content?.cnfrmBtnLbl}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ResetPwdModal;
